import { render } from "./lrbYTable4.vue?vue&type=template&id=5774d8f7&scoped=true"
import script from "./lrbYTable4.vue?vue&type=script&lang=js"
export * from "./lrbYTable4.vue?vue&type=script&lang=js"

import "./lrbYTable4.vue?vue&type=style&index=0&id=5774d8f7&lang=scss&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5774d8f7"]])

export default __exports__